<template>
    <b-card no-body>

        <b-modal id="create" title="Oluştur" no-close-on-esc no-close-on-backdrop>
            <bank-installment-create :banks="banks" v-model="bankInstallment"></bank-installment-create>
            <template #modal-footer><v-executer :action="create" text="Oluştur" :loading="loading"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :items-provider="provider"
                    search
                    :settings=false
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { SystemParameterApi } from '@/api/system-parameter'
import { BCard } from 'bootstrap-vue'
import BankInstallmentCreate from './components/BankInstallmentCreate.vue'
import { SystemDataApi } from '@/api/system-data'

export default {
    components:{
        BCard,
        BankInstallmentCreate
    },
    data() {
        return {
            loading:false,
            fields:[
                {name:'Banka',key:'BankName',thClass:'w-30'},
                {name:'Taksit',key:'Installment',thClass:'w-25'},
                {name:'Güneş Ürünü Taksidi',key:'IsForSunProduct'},
                {name:'Komisyon Var Mı',key:'IsCommissionApplied'},
                {name:'Komisyon',key:'CommissionRate',thClass:'w-20'},
            ],
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"secondary",action:this.delete }
            ],
            bankInstallment:{
                Id:null,
                Bank:null,
                BankName:null,
                Installment:null,
                IsForSunProduct:null,
                IsCommissionApplied:false,
                CommissionRate:null
            },
            banks:[]
        }
    },
    mounted(){
        this.getBanks()
    },
    methods:{
        provider(){
            return SystemParameterApi.BankInstallments()
        },
        clearForm(){
            this.bankInstallment.Id = null
            this.bankInstallment.Bank = null
            this.bankInstallment.BankName = null
            this.bankInstallment.Installment = null
            this.bankInstallment.IsForSunProduct = null
            this.bankInstallment.IsCommissionApplied = false
            this.bankInstallment.CommissionRate = null
        },
        edit(item){
            this.clearForm()
            this.bankInstallment.Id = item.Id
            this.bankInstallment.BankName = item.BankName
            this.bankInstallment.Bank = item.Bank
            this.bankInstallment.Installment = item.Installment
            this.bankInstallment.IsForSunProduct = item.IsForSunProduct
            this.bankInstallment.IsCommissionApplied = item.IsCommissionApplied
            this.bankInstallment.CommissionRate = item.CommissionRate
            this.$showModal('update')
        },
        createNew(){
            this.clearForm()
            this.$showModal('create')
        },
        create(){
            this.loading = true
            SystemParameterApi.CreateBankInstallment(this.bankInstallment).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.BankName} bankasının ${item.Installment} taksidini silecektir.`).then(result=>{
                if(result){
                    this.loading = true
                    SystemParameterApi.DeleteBankInstallment(item.Id).then(res=>{
                        this.$result(res)
                        this.loading = false
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    }).catch(err=>{
                        this.loading = false
                        this.$result(null,err)
                    })
                }
            })
        },
        getBanks(){
            SystemDataApi.Bank(0).then(res=>{
                this.loading = false
                if(res.data.Success){
                    this.banks = res.data.Data
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>